module.exports = __webpack_public_path__ + "img/JiHoUbRi.4b823324.png";